export default "__VITE_PUBLIC_ASSET__20c97d48__"